import { render } from "./Histoire.vue?vue&type=template&id=5385aff6&scoped=true&functionnal=true"
const script = {}

import "./Histoire.vue?vue&type=style&index=0&id=5385aff6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5385aff6"]])

export default __exports__